import Header from "../components/Header";
import Hero from "../components/Hero";
import AblaufSection from "../components/AblaufSection";
import WhyWhatsAppSection from "../components/WhyWhatsAppSection";
import TrustSection from "../components/TrustSection";
import FinalCtaSection from "../components/FinalCtaSection";
import ContactSection from "../components/ContactSection";
import FooterSection from "../components/FooterSection";
import WhatsAppButton from "../components/WhatsAppButton";
import ChatbotWidget from "../components/ChatbotWidget";
import CookieBanner from "../components/CookieBanner";
import MobileStickyCta from "../components/MobileStickyCta";
import { useEffect } from "react";

export default function Landing() {
  useEffect(() => {
    document.title = "Strombaron – Strom & Gas sparen, Angebot in 24h per WhatsApp";

    const description =
      "Strom- und Gastarife einfach per WhatsApp wechseln. Rechnung senden, Angebot in 24 Stunden erhalten – kostenlos, unverbindlich, DSGVO-konform. Für Privat und Gewerbe deutschlandweit.";
    const keywordsContent =
      "Stromtarif wechseln WhatsApp, Gastarif wechseln Deutschland, Strom und Gas sparen, Gasanbieter vergleichen, Stromanbieter vergleichen, Gewerbestrom, Strombaron, Herford";

    const ensureMeta = (name, content) => {
      let tag = document.head.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    };

    ensureMeta("description", description);
    ensureMeta("keywords", keywordsContent);
  }, []);

  return (
    <div className="min-h-screen bg-brand-bg text-brand-ink" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <AblaufSection />
        <WhyWhatsAppSection />
        <TrustSection />
        <FinalCtaSection />
        <ContactSection />
      </main>
      <FooterSection />
      <WhatsAppButton />
      <ChatbotWidget />
      <CookieBanner />
      <MobileStickyCta />
    </div>
  );
}
